<template>
    <div class="public_container payable_details_wrap unpaid_payment_details_wrap" v-loading="loading">
        <div class="returnNavBar">
            <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true"> </ReturnNavBar>
        </div>
        <div class="mobile_container">
            <div class="form_module_title">基本信息</div>
            <div class="form_module_content">
                <p>
                    客户公司名称：<span
                        class="link-label"
                        @click="
                            handleClickCustomerDetail(
                                unpaidDetails.basic_info.customer_id,
                                unpaidDetails.basic_info.customer_name
                            )
                        "
                        >{{ unpaidDetails.basic_info.customer_name }}</span
                    >
                </p>
                <p>
                    订单编号：<span class="link-label">{{ unpaidDetails.basic_info.order_num }}</span>
                </p>
                <div>客户负责人：{{ unpaidDetails.basic_info.salesperson_name || "--" }}</div>
                <div>
                    部门负责人：<span
                        v-if="
                            unpaidDetails.basic_info.department_leader &&
                            unpaidDetails.basic_info.department_leader.length
                        "
                        >{{ unpaidDetails.basic_info.department_leader.map((item) => item.name).join("、") }}</span
                    ><span v-else>--</span>
                </div>
                <template v-if="unpaidDetails.is_bad_debt == 1">
                    <div>
                        处理人：{{
                            (unpaidDetails.basic_info.mark_operate_info &&
                                unpaidDetails.basic_info.mark_operate_info.name) ||
                            "--"
                        }}
                    </div>
                    <p>处理日期：{{ unpaidDetails.basic_info.mark_operate_time || "--" }}</p>
                </template>
            </div>
            <div class="form_module_title">金额信息</div>
            <div class="form_module_content">
                <p>
                    订单总金额：{{
                        Number(unpaidDetails.amount_info.total_price).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        })
                    }}
                </p>
                <p>
                    已回款总金额：{{
                        Number(unpaidDetails.amount_info.total_repay_price).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        })
                    }}
                </p>
                <p>
                    未回款金额：{{
                        Number(unpaidDetails.amount_info.no_repay_price).toLocaleString(undefined, {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                        })
                    }}
                </p>
                <template v-if="unpaidDetails.is_bad_debt == 1">
                    <p>
                        坏账金额：{{
                            Number(unpaidDetails.amount_info.bad_debt_amount).toLocaleString(undefined, {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                            })
                        }}
                    </p>
                    <div>备注：{{ unpaidDetails.other_info.remark }}</div>
                    <p>附件：</p>
                    <div
                        class="file_upload_wrap file_upload_detail_wrap"
                        v-if="unpaidDetails.other_info.attachment && unpaidDetails.other_info.attachment.length"
                    >
                        <ul class="upload_file_list upload_file_list_detail">
                            <li
                                v-for="(file, fileIndex) in unpaidDetails.other_info.attachment"
                                class="upload_file_item"
                            >
                                <div class="file_left_wrap">
                                    <img
                                        alt=""
                                        class="file_img"
                                        src="https://download.hecoos.com/enlightv/2023-37/chyZ4zyQiQkR5byRwSCT.png"
                                    />
                                    <div class="file_info_wrap">
                                        <p class="file_name" v-text="file.file_name"></p>
                                        <p class="file_size" v-text="file.file_size"></p>
                                    </div>
                                </div>
                                <div class="file_right_wrap">
                                    <el-tooltip content="预览" effect="dark" placement="top">
                                        <span
                                            class="handle_icon_wrap"
                                            @click="
                                                handleClickPreview(fileIndex, file, unpaidDetails.other_info.attachment)
                                            "
                                        >
                                            <i class="iconfont icon-yanjing"></i>
                                        </span>
                                    </el-tooltip>
                                    <span class="line"></span>
                                    <el-tooltip content="下载" effect="dark" placement="top">
                                        <span class="handle_icon_wrap" @click="handleClickDownloadFile(file)">
                                            <i class="iconfont icon-daochu"></i>
                                        </span>
                                    </el-tooltip>
                                </div>
                            </li>
                        </ul>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>
<script>
import { OrderUnpaidDetail } from "@/api";
import { ImagePreview } from "vant";
import { getOSSData } from "@/utils/uploadOss";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
export default {
    name: "UnpaidPaymentDetails",
    components: { ReturnNavBar },
    data() {
        return {
            order_num: "",
            loading: false,
            defaultImg: require("@/assets/images/default.jpg"),
            unpaidDetails: {
                is_bad_debt: 0, // 1坏账 0正常
                basic_info: {},
                amount_info: {},
                other_info: {},
            },
        };
    },
    created() {
        if (this.$route.query) {
            this.order_num = this.$route.query.order_num;
            if (this.order_num) {
                this.getOrderUnpaidDetail();
            }
        }
    },
    methods: {
        // 详情
        getOrderUnpaidDetail() {
            this.loading = true;
            OrderUnpaidDetail({ order_num: this.order_num })
                .then((res) => {
                    if (res.code === 200) {
                        const data = res.data || {};
                        this.unpaidDetails = data;
                    }
                    this.loading = false;
                })
                .catch(() => {
                    this.loading = false;
                });
        },
        //附件预览事件
        handleClickPreview(fileIndex, file, allFile) {
            if (file.file_type.includes("image")) {
                // this.previewImgList = [file.file_path];
                // this.previewImgSrc = file.file_path;
                // this.$refs.preview_img.showViewer = true;
                this.handleClickPreviewImg(
                    fileIndex,
                    allFile.map((item) => item.file_path)
                );
            } else {
                if (file.file_type.includes("pdf")) {
                    window.open(file.file_path);
                } else {
                    this.$toast("当前文件格式不支持预览，请下载后查看");
                }
            }
        },
        //附件下载
        handleClickDownloadFile(file) {
            getOSSData(file.file_path, file.file_name);
        },
        // 图片预览
        handleClickPreviewImg(index, images) {
            ImagePreview({
                images,
                startPosition: index,
            });
        },
        // 查看客户详情
        handleClickCustomerDetail(customer_id, customer_name) {
            this.$router.push({
                name: "CustomerPrivateSeasDetail",
                params: {
                    isPush: true,
                },
                query: {
                    customer_id,
                    name: customer_name,
                },
            });
        },
    },
};
</script>
<style lang="scss" scoped>
.ml_10 {
    margin-left: 10px;
}
.payable_details_wrap {
    background: rgba(255, 255, 255, 1);
    .mobile_container {
        background: rgba(255, 255, 255, 1);
        .form_module_title {
            font-weight: 700;
            font-size: 14px;
            line-height: 24px;
            color: #333333;
            padding: 10px 16px 10px 28px;
            position: relative;

            &::before {
                content: "";
                width: 4px;
                height: 22px;
                opacity: 1;
                border-radius: 20px;
                background: #2990ff;
                position: absolute;
                left: 16px;
            }
        }
        .form_module_content {
            padding: 0 16px;
            & > p,
            & > div {
                font-size: 14px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 22px;
                color: rgba(102, 102, 102, 1);
                margin-bottom: 8px;
            }
        }
        ul {
            padding: 0 16px;
            li {
                border-radius: 6px;
                background: rgba(249, 249, 249, 1);
                padding: 8px 10px 2px;
                margin-bottom: 8px;
                & > p,
                & > div {
                    font-size: 14px;
                    font-weight: 400;
                    letter-spacing: 0px;
                    line-height: 22px;
                    color: rgba(102, 102, 102, 1);
                    margin-bottom: 8px;
                }
            }
            .form_module_content {
                padding: 0;
            }
        }
        .voucher_list {
            margin-top: 10px;
            padding: 0;
            display: flex;
            gap: 8px;

            .voucher_item {
                width: 44px;
                height: 44px;
                cursor: pointer;
                position: relative;
                text-align: center;
                line-height: 44px;
                border-radius: 4px;

                .van-image {
                    max-width: 100%;
                    max-height: 100%;
                }

                img {
                    max-width: 100%;
                    max-height: 100%;
                    object-fit: cover;
                }

                .icon-guanbi_dise {
                    position: absolute;
                    right: -8px;
                    top: -8px;
                    cursor: pointer;
                    font-size: 16px;
                    color: rgba(191, 191, 191, 1);
                    line-height: 16px;
                }
            }
        }
    }
}
.unpaid_payment_details_wrap {
    .file_upload_wrap {
        height: auto;
        .upload_file_list {
            padding: 0;
        }
    }
}
</style>
<style lang="scss">
.van-image-preview__overlay {
    background: rgba(0, 0, 0, 0.3);
}

.van-image-preview {
    .van-image-preview__index {
        top: auto;
        bottom: 26px !important;
        text-shadow: none;
    }
}
</style>
